// import { useEffect, useMemo, useState } from "react";
// import Particles, { initParticlesEngine } from "@tsparticles/react";
// import { loadSlim } from "@tsparticles/slim";

// export default function ParticlesBg() {
//   const [init, setInit] = useState(false);

//   useEffect(() => {
//     initParticlesEngine(async (engine) => {
//       await loadSlim(engine);
//     }).then(() => {
//       setInit(true);
//     });
//   }, []);

//   const options = useMemo(
//     () => ({
//       background: {
//         color: {
//           value: "#f7f7f7",
//         },
//       },
//       fullScreen: false,
//       fpsLimit: 120,
//       interactivity: {
//         events: {
//           onClick: {
//             enable: false,
//             mode: "push",
//           },
//           onHover: {
//             enable: true,
//             mode: "repulse",
//           },
//         },
//         modes: {
//           push: {
//             quantity: 4,
//           },
//           repulse: {
//             distance: 200,
//             duration: 0.4,
//           },
//         },
//       },
//       particles: {
//         color: {
//           value: "#393939",
//         },
//         links: {
//           color: "#333",
//           distance: 150,
//           enable: true,
//           opacity: 0.5,
//           width: 1,
//         },
//         move: {
//           direction: "none",
//           enable: true,
//           outModes: {
//             default: "bounce",
//           },
//           random: false,
//           speed: 2.5,
//           straight: false,
//         },
//         number: {
//           density: {
//             enable: true,
//             area: 800, // مساحة أكبر لتوزيع الجسيمات
//           },
//           value: 300, // تم زيادة عدد الجسيمات من 180 إلى 300
//         },
//         opacity: {
//           value: 0.5,
//         },
//         shape: {
//           type: "circle",
//         },
//         size: {
//           value: { min: 2, max: 5 }, // تصغير حجم الجسيمات لتحسين الأداء
//         },
//       },
//       detectRetina: true,
//     }),
//     []
//   );

//   if (init) {
//     return (
//       <Particles
//         height={"100%"}
//         className="h-full w-full absolute -z-10 top-0"
//         id="tsparticles"
//         options={options}
//       />
//     );
//   }

//   return null;
// }

import { useEffect, useMemo, useState } from "react";
import Particles, { initParticlesEngine } from "@tsparticles/react";
import { loadSlim } from "@tsparticles/slim"; // if you are going to use `loadSlim`, install the "@tsparticles/slim" package too.

export default function ParticlesBg() {
  const [init, setInit] = useState(false);

  useEffect(() => {
    initParticlesEngine(async (engine) => {
      await loadSlim(engine);
      //await loadBasic(engine);
    }).then(() => {
      setInit(true);
    });
  }, []);

  const options = useMemo(
    () => ({
      background: {
        color: {
          value: "#f7f7f7",
        },
      },
      fullScreen: false,
      fpsLimit: 120,
      interactivity: {
        events: {
          onClick: {
            enable: false,
            mode: "push",
          },
          onHover: {
            enable: true,
            mode: "repulse",
          },
        },
        modes: {
          push: {
            quantity: 4,
          },
          repulse: {
            distance: 200,
            duration: 0.4,
          },
        },
      },
      particles: {
        color: {
          value: "#393939",
        },
        links: {
          color: "#333",
          distance: 150,
          enable: true,
          opacity: 0.5,
          width: 1,
        },
        move: {
          direction: "none",
          enable: true,
          outModes: {
            default: "bounce",
          },
          random: false,
          speed: 2.5,
          straight: false,
        },
        number: {
          density: {
            enable: true,
          },
          value: 180,
        },
        opacity: {
          value: 0.5,
        },
        shape: {
          type: "circle",
        },
        size: {
          value: { min: 2, max: 5 },
        },
      },
      detectRetina: true,
    }),
    []
  );

  if (init) {
    return (
      <Particles
        height={"100"}
        className="h-full w-full absolute -z-10 top-0 "
        // style={{ zIndex: -1, position: "absolute" }}
        id="tsparticles"
        options={options}
      />
    );
  }

  return null;
}
